import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { injectIntl, defineMessages } from 'react-intl';
import Slider from 'react-slick';

import EventList from '../components/content/lists/EventList';
import SocialButtons from '../components/content/SocialButtons';
import LoadingView from '../components/content/LoadingView';

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventSearchQuery: '',
      isFiltered: false,
      isFetching: false,
    };

    this.handleEventSearchInputChanged = this.handleEventSearchInputChanged.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this._refetch = this._refetch.bind(this);
  }

  handleEventSearchInputChanged(event) {
    this.setState({
        eventSearchQuery: event.target.value,
      }, () => {
        // If the input is cleared, we must refetch the events
        // w/o filter query (`$query`)
        if (this.state.eventSearchQuery.length === 0) {
          this._noFilterFetch();
        }
      },
    );
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this._refetch();
    }
  }

  _noFilterFetch() {
    this.setState({ 
      isFiltered: true, 
      isFetching: true 
    });
    this.props.relay.refetch(
      { query: null },
      null,
      () => this.setState({ 
        isFiltered: false, 
        isFetching: false 
      }),
    );
  }

  _refetch() {
    const { eventSearchQuery } = this.state;
    if (eventSearchQuery.length !== 0) {
      this.setState({ 
        isFiltered: true, 
        isFetching: true,
      });
      this.props.relay.refetch(
        { query: eventSearchQuery },
        null,
        () => this.setState({ 
          isFiltered: false, 
          isFetching: false 
        }),
      );
    }
  }

  render() {
    const { intl, viewer } = this.props;
    const { eventSearchQuery, isFiltered, isFetching } = this.state;

    return (
      <Fragment>
        <div className="hero-container-outer">
          <Slider
            autoplay={true}
            arrows={false}
            dots={false}
            draggable={false}
            swipe={false}
            pauseOnHover={false}
            touchMove={false}
          >
            {this.props.viewer.config.frontendCarousel.map((url,index) => (
              <div className="homepage-slideshow-slide" key="index">
                <img src={url} alt=""/>
              </div>
            ))}
          </Slider>
          <div className="homepage-slideshow-cover"></div>
          <div className="hero-container absolute-cover-center">
            <div className="hero-text container-full-width container-960">
              <p>photography</p>
              <p>for the love of sport</p>
            </div>
            <div className="hero-search container-full-width container-960">
              <input
                className="hero-search-textfield"
                onChange={this.handleEventSearchInputChanged}
                onKeyPress={this.handleKeyPress}
                placeholder={intl.formatMessage(translations.eventSearchInputHint)}
                type="text"
                value={eventSearchQuery}
              />
            </div>
          </div>
        </div>
        <SocialButtons language={intl.locale} />
        {isFetching ? (
            <LoadingView />
        ) : (
          <EventList viewer={viewer} hasFilter={isFiltered ? true : false} />
        )}
      </Fragment>
    );
  }
}

HomePage.propTypes = {
  intl: PropTypes.object,
  viewer: PropTypes.object,
  relay: PropTypes.object,
};

const translations = defineMessages({
  eventSearchInputHint: {
    id: 'homePage.eventSearchInputHint',
    defaultMessage: 'Search for event',
  },
});

export { HomePage };

export default createRefetchContainer(
  injectIntl(HomePage),
  {
    viewer: graphql`
      fragment HomePage_viewer on Viewer {
        config {
          frontendCarousel
        }
        ...EventList_viewer
      }
    `,
  },
  graphql`
    query HomePageQuery($count: Int!, $cursor: String, $query: String) {
      viewer {
        ...HomePage_viewer
      }
    }
  `,
);
